/**
 * Generates a subtitle string based on the current filter values
 * @param {Object} filters - The filter values object
 * @returns {string} A formatted subtitle string
 */
import i18n from "i18n";

const FILTER_LABELS = {
  riskRatings: 'Risk Ratings',
};

// Map filter types to entity caption keys so "All X" localises (plural form).
const FILTER_ENTITY_KEYS = {
  department: 'entity.department',
  model: 'entity.model',
  asset: 'entity.asset',
  role: 'entity.role',
  riskRating: 'entity.riskRating',
  riskRatings: 'entity.riskRating',
  user: 'entity.user',
  interval: 'entity.interval',
  defectStatus: 'entity.defectStatus',
  defectStatusType: 'entity.defectStatus',
  defectType: 'entity.defectType',
  workOrder: 'label.workOrder',
  workOrderStatus: 'label.workOrder',
};

export const getFilterSubtitle = (filters) => {
  const parts = [];

  // Loop through all available filters
  Object.entries(filters).forEach(([filterType, filterData]) => {
    // Skip question filter as it will be displayed separately
    if (filterType === 'question') return;
    
    if (filterData?.value) {
      // Handle timeframe filter
      if (filterType === 'timeframe' && filterData.value.name) {
        parts.push(filterData.value.name);
      } 
      // Handle service filter with displayDetails
      else if (filterType === 'service' && filterData.value.displayDetails) {
        parts.push(filterData.value.displayDetails);
      }
      // Handle other filters with id/name pattern
      else if (filterData.value.id !== undefined) {
        const filterName =
          FILTER_LABELS[filterType] ||
          filterType.charAt(0).toUpperCase() + filterType.slice(1);
        const pluralized = filterName.endsWith('s') ? filterName : `${filterName}s`;
        const entityLabel = FILTER_ENTITY_KEYS[filterType]
          ? i18n.t(FILTER_ENTITY_KEYS[filterType], { count: 2 })
          : pluralized;
        parts.push(
          filterData.value.id === ''
            ? i18n.t('label.allEntity', { entity: entityLabel })
            : filterData.value.name
        );
      }
    }
  });

  return parts.length > 0 ? parts.join(' - ') : i18n.t('label.showAll');
}; 
